'use strict';

$(function() {
  var monthtext = [
    '',
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
  ];
  var monthValue = [
    '',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12'
  ];

  function customDateNumber(num) {
    if (num <= 9) {
      return '0' + num;
    }
    return num;
  }
  function populatedropdown(day, month, year) {
    var today = new Date();
    var dayfield = document.getElementsByClassName(day);
    var monthfield = document.getElementsByClassName(month);
    var yearfield = document.getElementsByClassName(year);
    let yearDropdownLimit = 120;
    let yearDropdownUpperLimit = 121;

    // proceed only if day dropdown actually exists
    if (dayfield.length > 0) {
      for (var i = 1; i <= 31; i += 1) {
        // i = customDateNumber(i)
        dayfield[0].options[i] = new Option(i, customDateNumber(i));

        if (dayfield[1]) {
          dayfield[1].options[i] = new Option(i, customDateNumber(i));
        }
      }

      for (var m = 1; m <= 12; m += 1) {
        monthfield[0].options[m] = new Option(monthtext[m], monthValue[m]);

        if (monthfield[1]) {
          monthfield[1].options[m] = new Option(monthtext[m], monthValue[m]);
        }
      }

      if ($('#is-reorder-register-page').length > 0) {
        yearDropdownLimit = 100;
        yearDropdownUpperLimit = 101;
      }

      var thisyear = today.getFullYear() - yearDropdownLimit;

      for (var y = 1; y <= yearDropdownUpperLimit; y += 1) {
        yearfield[0].options[y] = new Option(thisyear, thisyear);

        if (yearfield[1]) {
          yearfield[1].options[y] = new Option(thisyear, thisyear);
        }
        thisyear += 1;
      }
    }
  }

  populatedropdown('daySelect', 'monthSelect', 'yearSelect');
});
